
let Permissions = require('@/mixins/Management/Permissions')
let Searchable = require('@/mixins/Searchable')
let Paginator = require('@/mixins/Paginator')

module.exports = {

    mixins:[ Permissions, Paginator, Searchable ],

    data(){
        return {
            roles: [],
            displayRole: null,
        }
    },

    mounted() {
        this.fetchRoles()
    },

    methods: {

        requestPaginate: _.debounce(function() {
            this.fetchRoles();
        }, 300),

        fetchRoles(){
            App.request().get(`/management/roles?page=${this.paginator.current_page}&per_page=${this.paginator.per_page}&query=${this.searchKey}&paginate`).then(response => {
                this.paginator = response.data;
                this.roles = this.paginator.data;
                if(this.roles.length) this.displayRole = this.roles[0];
                this.fetchPermissions();
            })
        },

        updateRole(role){
            this.displayRole = role;
            this.openModal('update-role');
        },

        deleteRole(role){
            this.displayRole = role;
            this.openModal('delete-role');
        },
    },
}
